import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { Url } from '@wix/da-url';
import { pushModal } from '@wix/da-shared-react/pkg/Modals/redux/basicActions';
import { ModalType } from '@wix/da-shared-react/pkg/Modals/redux/types';
import { getPromos } from '@wix/da-shared-react/pkg/publicSession/selectors';
import { canPerformPageAction } from '../../../../selectors/groups';
import { AppState } from '../../../../../types/store';
import { PagePriv } from '../../../../../types/pagePrivileges';
import { getProfileOwnerIsWatcher } from '../../../../selectors/users';
import { Props } from './SubNavBarDesktopInner';
import { toggleSkinSelector } from '../../../../actions/profileSkins';
import { getProfileSkin } from '../../../../selectors/profileSkins';

type StateProps = Pick<
  Props,
  'currentPromo' | 'isProfileOwnerWatchingCurrentUser' | 'profileSkin'
>;
type DispatchProps = Pick<Props, 'showBlockModal' | 'onShowSkinSelector'>;
type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => ({
  currentPromo: getPromos(state)?.[0],
  canRespondToGroupNotifications: canPerformPageAction(
    state,
    PagePriv.CAN_RESPOND_TO_GROUP_NOTIFICATIONS
  ),
  isProfileOwnerWatchingCurrentUser: getProfileOwnerIsWatcher(state),
  profileSkin: getProfileSkin(state),
});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = (
  dispatch,
  ownProps
) => ({
  onShowSkinSelector: () => dispatch(toggleSkinSelector()),
  showBlockModal: () =>
    dispatch(
      pushModal(ModalType.USER_BLOCK, {
        wrapInModal: true,
        params: {
          user: ownProps.profileOwnerUser,
          redirectLocation: Url.browseHomeLink(),
        },
      })
    ),
});

export default connect(mapStateToProps, mapDispatchToProps);
